import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { LifeBuoy } from "lucide-react";

export default function Support() {
  const [f, setF] = useState({ subject: "", message: "", contact_email: "", contact_phone: "" });
  const [faq, setFaq] = useState([]);
  useEffect(() => { api.get("/faq").then((r) => setFaq(r.data || [])); }, []);
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/support", f); toast.success("Mesajınız alındı"); setF({ subject: "", message: "", contact_email: "", contact_phone: "" }); }
    catch { toast.error("Gönderilemedi"); }
  };
  return (
    <div className="max-w-3xl mx-auto px-4 py-6">
      <div className="flex items-center gap-2 mb-3"><LifeBuoy className="w-7 h-7 text-[#e11d2a]" /><h1 className="text-2xl md:text-3xl font-black">Destek</h1></div>
      <form onSubmit={submit} className="bg-white border border-gray-100 rounded-lg p-5 grid gap-3">
        <input required value={f.subject} onChange={(e) => setF({ ...f, subject: e.target.value })} placeholder="Konu" className="px-3 py-2 border border-gray-200 rounded-md text-sm" />
        <textarea required rows={5} value={f.message} onChange={(e) => setF({ ...f, message: e.target.value })} placeholder="Mesajınız..." className="px-3 py-2 border border-gray-200 rounded-md text-sm"></textarea>
        <input value={f.contact_email} onChange={(e) => setF({ ...f, contact_email: e.target.value })} placeholder="İletişim email (opsiyonel)" className="px-3 py-2 border border-gray-200 rounded-md text-sm" />
        <input value={f.contact_phone} onChange={(e) => setF({ ...f, contact_phone: e.target.value })} placeholder="Telefon (opsiyonel)" className="px-3 py-2 border border-gray-200 rounded-md text-sm" />
        <button type="submit" className="px-4 py-2 bg-[#e11d2a] text-white rounded-md font-semibold text-sm">Gönder</button>
      </form>
      <h2 className="text-xl font-bold mt-8 mb-3">Sıkça Sorulan Sorular</h2>
      <div className="space-y-2">
        {faq.map((q) => (
          <details key={q.id} className="bg-white border border-gray-100 rounded-lg p-4">
            <summary className="cursor-pointer font-semibold">{q.question}</summary>
            <p className="text-sm text-gray-700 mt-2 whitespace-pre-wrap">{q.answer}</p>
          </details>
        ))}
      </div>
    </div>
  );
}
